module.exports = __webpack_public_path__ + "img/1440199403.e52294d1.jpg";